<div class="background1">
  <div class="successMessage alert-dismissible">
    <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}

      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
      {{ warningMessage }}

      <button
        *ngIf="warningMessage"
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  </div>

  <div class="container-fluid">
    <div class="d-flex flex-row align-items-center justify-content-between">
      <div class="p-2 flex-grow-1">
        <h2 class="heading">Procurement</h2>
      </div>

      <!-- ACTION dropdown aligned to the right -->
      <div class="p-2">
        <div class="drpchildctrl d-flex align-items-center">
          <label class="searchLable me-2 mb-0">ACTION</label>
          <p-dropdown
            [virtualScroll]="true"
            [itemSize]="30"
            placeholder="Select"
            [style]="{ width: '200px', height: '25px' }"
            scrollHeight="100px"
            [options]="actionOptions"
            optionLabel="action_name"
            [appendTo]="'body'"
            [autoWidth]="false"
            [ngModel]="selectedAction"
            (onChange)="onActionSelect($event.value)"
            [filterBy]="'action_name'"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row">
            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DEST CODE</label>
                <p-multiSelect
                  [(ngModel)]="selectedDestCode"
                  [showToggleAll]="false"
                  (onChange)="onDestCodeChange()"
                  [options]="destCodeList"
                  optionLabel="dest_code"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'"
                  autoWidth="true"
                  [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  [appendTo]="'body'"
                  [panelStyle]="{ width: '60%' }"
                >
                </p-multiSelect>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">ORDER DT FROM </label>
                <input
                  [(ngModel)]="ordDate"
                  [max]="ordDateTo"
                  class="form-control-sm"
                  type="date"
                  autoWidth="false"
                />
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">ORDER DT TO</label>
                <input
                  [(ngModel)]="ordDateTo"
                  [min]="ordDate"
                  class="form-control-sm"
                  type="date"
                  autoWidth="false"
                />
              </div>
            </div> -->
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DOCK</label>
                <p-dropdown
                  [(ngModel)]="selectedDock"
                  [showToggleAll]="false"
                  [(ngModel)]="selectedDock"
                  [options]="dockList"
                  (onChange)="dockChange()"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--"
                  [virtualScroll]="true"
                  [itemSize]="12"
                  autoWidth="false"
                  [style]="{ width: '110%' }"
                  [resetFilterOnHide]="true"
                  optionLabel="dock"
                  [panelStyle]="{ width: '70%' }"
                  selected="false"
                  [appendTo]="'body'"
                  [filter]="true"
                  [filterBy]="'dock'"
                >
                </p-dropdown>
              </div>
            </div>
            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">AIR CASE CODE</label>
                <p-multiSelect
                  [showToggleAll]="false"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'"
                  [(ngModel)]="selectedAircaseCode"
                  autoWidth="true"
                  [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  (onChange)="airCaseCodeChange()"
                  selected="false"
                  [options]="airCaseCode"
                  optionLabel="air_case_code"
                  [appendTo]="'body'"

                >
                </p-multiSelect>
              </div>
            </div> -->
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">KANBAN</label>
                <p-dropdown
                  [(ngModel)]="selectedKanban"
                  (onChange)="onKanbanChange()"
                  [options]="kanbanList"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  [virtualScroll]="true"
                  [itemSize]="12"
                  autoWidth="false"
                  placeholder="--Select--"
                  [style]="{ width: '110%' }"
                  [resetFilterOnHide]="true"
                  optionLabel="kanban"
                  [panelStyle]="{ width: '80%' }"
                  selected="false"
                  [disabled]="disableKanban"
                  [appendTo]="'body'"
                  [panelStyle]="{ width: '100%' }"
                  [filter]="true"
                  [filterBy]="'kanban'"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">PART NO</label>
                <p-dropdown
                  [(ngModel)]="selectedPartNo"
                  (onChange)="onPartNoChange()"
                  [options]="partNoList"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--"
                  [virtualScroll]="true"
                  [itemSize]="12"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  optionLabel="item_id"
                  [panelStyle]="{ width: '140%' }"
                  [disabled]="disablePartNumber"
                  [appendTo]="'body'"
                  [filter]="true"
                  [filterBy]="'item_id'"
                >
                </p-dropdown>
              </div>
            </div>

            <div class="col-xl-1 col-md-2 col-sm-3" style="height: 23.98px">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">WEEK</label>
                <input
                  class="form-control-sm"
                  type="date"
                  [(ngModel)]="selectedDate"
                />

                <!-- <p-multiSelect
                  [(ngModel)]="selectedStatus"
                  [showToggleAll]="false"
                  [options]="statusList"
                  optionLabel="air_order_status"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'"
                  
                  autoWidth="true"
                  [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  
                  selected="false"
                  [appendTo]="'body'"
                >
                </p-multiSelect> -->
              </div>
            </div>

            <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon">
                <img
                  src="./assets/images/Group 115380.png"
                  alt="refresh icon"
                  (click)="onResetDropDown()"
                />
              </label>
              <label class="resetLabel" (click)="onResetDropDown()"
                >Reset</label
              >
              <span class="vertical"></span>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 search">
              <button class="search_btn" (click)="onSearch(0)">SEARCH</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <!-- <div class="col-sm-6">
        <span class="edit_icon">
          <img
            class="img-tool"
            (click)="exportAsXLSX()"
            src="./assets/images/download.svg"
            alt="download icon"
            title="Download"
          />
        </span>
      </div> -->

      <div class="col-sm-4"></div>

      <!-- <div class="col-sm-4">
        <div class="records">
          <p-multiSelect #dd
            class="page-drpdwn-label showhide"
            [(ngModel)]="selectedShowHideList"
            (onChange)="onShowHideChange($event)"
            [options]="showHideList"
            optionLabel="label"
            [displaySelectedLabel]="false"
            [defaultLabel]="'SHOW/HIDE COLUMN'"
            [showTransitionOptions]="'0ms'"
            [hideTransitionOptions]="'0ms'"
            autoWidth="true"
            [style]="{ width: '50%', background: '#F5F5F5' }"
            [resetFilterOnHide]="true"
          >
            <p-footer>
              <div class="flex justify-content-between p-1" style="width: 100%; padding: 10px;">
                <button type="button" (click)="saveShowHide(); dd.hide()" class="save_btn" >Save</button>
              </div>
            </p-footer>
          </p-multiSelect>
        </div>
      </div> -->

      <!-- <div class="col-sm-2">
        <div class="records">
          <label class="page-drpdwn-label">RECORDS / PAGE:</label>
          <select
            class="page-drpdwn"
            (change)="onPageSizeChanged()"
            [(ngModel)]="paginationPageSize"
          >
            <option value="10" selected>10</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="{{ rowData.length }}">All</option>
          </select>
        </div>
      </div> -->
    </div>
  </div>

  <div class="filter d-flex flex-row w-100" *ngIf="isView">
    <!-- Column 1 -->
    <div class="d-flex flex-column col-lg-4 col-md-6 col-12 pe-3">
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">KANBAN</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="kanbanValue"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">PART NO</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="partValue"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">DOCK</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="dockValue"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">SPECIALIST</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="specialistValue"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">PC ADDRESS</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [(value)]="pcAddress"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">LS ADDRESS</label>
        <textarea
          class="textareaColour"
          [rows]="lineSideAddress?.split('\n').length || 2"
          style="width: 100%"
          readonly
          [(ngModel)]="lineSideAddress"
        ></textarea>
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">DESCRIPTION</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="description"
          readonly
        />
      </div>
    </div>

    <!-- Column 2 -->
    <div class="d-flex flex-column col-lg-4 col-md-6 col-12 pe-3">
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">INV POLICY</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="inventoryPolice"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">VAN FROM</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="vanningFrom"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">LINEOFF FROM</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="lineoffDateFrom"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">ORDER LOT</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="orderlotValue"
          readonly
        />
      </div>

      <div class="d-flex align-items-left mb-3">
        <label class="col-4">BOX LOT</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="orderlotValue"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">PARTS COUNT GROUP</label>
        <textarea
          class="textareaColour"
          [rows]="getSortedPartsControlGroup().split('\n').length || 2"
          style="width: 100%"
          readonly
        >{{ getSortedPartsControlGroup() }}</textarea>
      </div>
      
      
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">VEHICLE</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="vehicleCode"
          readonly
        />
      </div>
    </div>

    <!-- Column 3 -->
    <div class="d-flex flex-column col-lg-4 col-md-6 col-12">
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">STORE RACK CAPACITY</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="storeRackCapacity"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">VAN TO</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="vanningTo"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">LINEOFF TO</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="lineoffDateTo"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">LIFE CYCLE CODE</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="lifeCycle"
          readonly
        />
      </div>

      <div class="d-flex align-items-left mb-3">
        <label class="col-4">INV ADJ</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="invAdj"
          readonly
        />
      </div>
      <div class="d-flex align-items-left mb-3">
        <label class="col-4">VEND SHARE</label>
        <input
          class="key"
          type="text"
          style="width: 100%"
          [value]="shareValue"
          readonly
        />
      </div>
    </div>
  </div>

 
  <br />
  <div class="grid-agg px-0">
    <ag-grid-angular
      *ngIf="isView"
      #osPartsGrid
      style="width: 100%; height: 26vh"
      class="ag-theme-balham grid-items"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [rowData]="rowData1"
      [suppressCellSelection]="true"
      [headerHeight]="40"
    >
    </ag-grid-angular>
  </div>

  <!-- <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div id="dvgrid" class="gridStyle" *ngIf="isEditMode">
          <div class=" d-flex input-container m-2">
       
  
            <div class="d-flex row col-4">
              <div class="col-3">
                <label for="input1">Kanban</label>
              </div>
              <div class="col-9">
                <input type="text" id="input1" class="form-control" />
              </div>
            </div>
            <div class="d-flex row col-4">
              <div class="col-3">
                
              </div>
              <div class="col-9">
                
              </div>
            </div>
            <div class="d-flex row col-4">
              <div class="col-3">
                <label for="input1">Vehicle</label>
              </div>
              <div class="col-9">
                <input type="text" id="input1" class="form-control" />
              </div>
            </div>
            
          </div>
          <div class="  d-flex input-container ">
            <div class="d-flex row col-4">
              <div class="col-3">
                <label for="input1">PART NO</label>
              </div>
              <div class="col-9">
                <input type="text" id="input1" class="form-control" />
              </div>
            </div>
            <div class="d-flex row col-4">
              <div class="col-3">
                <label for="input1">VAN FROM</label>
              </div>
              <div class="col-9">
                <input type="text" id="input1" class="form-control" />
              </div>
            </div>
            <div class="d-flex row col-4">
              <div class="col-3">
                <label for="input1">VAN TO</label>
              </div>
              <div class="col-9">
                <input type="text" id="input1" class="form-control" />
              </div>
            </div>
          </div>
          <br>
          <div>
            <ag-grid-angular #osPartsGrid style="width: 100%; top: 1%; margin-bottom: 5%" class="ag-theme-balham"
              [columnDefs]="columnDefs" [rowData]="rowData" [rowSelection]="rowSelection" [gridOptions]="gridOptions"
              [pagination]="true" [paginationPageSize]="paginationPageSize" [context]="context"
              [suppressClickEdit]="suppressClickEdit" [frameworkComponents]="frameworkComponents"
              [tooltipShowDelay]="tooltipShowDelay" [tooltipMouseTrack]="true" [editType]="editType"
              [groupRowsSticky]="groupRowsSticky" [autoGroupColumnDef]="autoGroupColumnDef"
              [groupDefaultExpanded]="groupDefaultExpanded" [editType]="editType" [showOpenedGroup]="showOpenedGroup"
              [groupSelectsChildren]="groupSelectsChildren" [suppressRowClickSelection]="suppressRowClickSelection"
              [suppressAggFuncInHeader]="suppressAggFuncInHeader" [groupDisplayType]="groupDisplayType">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple"
  >
    <p style="font-size: 20px; color: white">Loading... Please wait...</p>
  </ngx-spinner>
</div>
